import React from 'react';
import {
  LockOpenRounded as IconDeviceOpened,
  LockRounded as IconDeviceClosed,
  PowerSettingsNewRounded as IconDeviceStatus,
  QueryBuilder as IconDefaultEvent,
  VpnKeyRounded as IconRFID,
  PowerRounded as IconDevicePower,
  PowerOffRounded as IconDevicePowerOff,
  GetAppRounded,
  ErrorRounded,
  WarningRounded,
  SaveAltRounded,
  NotificationsActiveRounded,
  CallReceivedRounded,
  LinkRounded,
  OutlinedFlagRounded,
  DoubleArrowRounded,
  EditRounded,
  CheckCircleOutlineRounded,
  TimerOffRounded,
  FlagRounded,
  NotificationsPausedRounded
} from '@mui/icons-material';
import NotificationsPausedIcon from '@mui/icons-material/NotificationsPaused';
import IconTemperature from './temperature';
import AlertConfirmIcon from './alert-confirm';
import AlertConfirmEditIcon from './alert-confirm-edit';

export default function eventIcon(item, props = {}, customStyles = {}) {
  const details = item;
  switch (item.identifier) {
    case 'open': // old
    case 'unlock':
    case 'do':
    case 'dm':
      return <IconDeviceOpened {...props} />;
    case 'close': // old
    case 'lock':
    case 'dc':
      return <IconDeviceClosed {...props} />;
    case 'on':
      return <IconDeviceStatus {...props} />;
    case 'off':
      return <IconDeviceStatus {...props} />;
    case 'smbmr':
      return <CallReceivedRounded {...props} />;
    case 'shipment_40010':
    case 'appliance_50010':
    case 'appliance_50020':
      return <DoubleArrowRounded {...props} />; // created
    case 'shipment_40013': // stopped
      return <OutlinedFlagRounded {...props} />;
    case 'shipment_40014': // shipment done
      return <FlagRounded {...props} />;
    case 'shipment_40016': // shipment not in time
    case 'shipment_40046': // checkpoint not in time
      return <TimerOffRounded {...props} />;
    case 'shipment_40020': // deeplink
      return <LinkRounded {...props} />;
    case 'shipment_40044': // checkpoint done
      return <CheckCircleOutlineRounded {...props} />;
    case 'rfid': // old
    case 'nfc':
      return <IconRFID {...props} />;
    case 'target': // old
      return <IconTemperature {...props} />;
    case 'ac': // old
      switch (details.present) {
        case '1':
          return <IconDevicePower {...props} />;
        default:
          return <IconDevicePowerOff {...props} />;
      }
    case 'ac1':
      return (
        <IconDevicePower {...props} />
      );
    case 'ac0':
      return <IconDevicePowerOff {...props} />;
    case 'set':
      return <SaveAltRounded {...props} />;
    case 'dw':
      return <WarningRounded {...props} style={{ color: '#FACE31' }} />;
    case 'ex':
      return <WarningRounded {...props} style={{ color: '#FACE31' }} />;
    case 'appliance_50055':
    case 'shipment_40075':
      if (item?.details?.acceptance) {
        return <NotificationsPausedIcon {...props} style={{ ...customStyles }} />;
      }
      return <NotificationsActiveRounded {...props} style={{ color: '#FF4635', ...customStyles }} />; // alert triggered
    case 'project_10020':
    case 'shipment_40030':
    case 'shipment_40040':
    case 'shipment_40050':
    case 'shipment_40060':
    case 'shipment_40070':
    case 'shipment_40080':
    case 'shipment_40090':
    case 'appliance_50030':
    case 'appliance_50040':
    case 'appliance_50050':
    case 'appliance_50060':
      return <GetAppRounded {...props} style={{ transform: 'rotate(270deg)' }} />;
    case 'shipment_40011':
    case 'shipment_40041':
    case 'shipment_40051':
    case 'shipment_40091':
    case 'device_30011':
    case 'appliance_50011':
    case 'appliance_50021':
    case 'appliance_50031':
    case 'appliance_50051':
    case 'appliance_50061':
      return <EditRounded {...props} />;
    case 'shipment_40032':
    case 'shipment_40042':
    case 'shipment_40052':
    case 'shipment_40062':
    case 'shipment_40072':
    case 'shipment_40082':
    case 'shipment_40092':
    case 'appliance_50042':
    case 'appliance_50052':
    case 'appliance_50062':
    case 'project_10022':
      return <GetAppRounded {...props} style={{ transform: 'rotate(90deg)' }} />;
    case 'err':
      return <ErrorRounded {...props} style={{ color: '#FF4635' }} />;
    case 'alert_acceptance':
      return <NotificationsPausedRounded {...props} />;
    case 'shipment_40100':
    case 'appliance_50070':
      return <AlertConfirmIcon {...props} />;
    case 'shipment_40101':
    case 'shipment_40102':
    case 'appliance_50071':
    case 'appliance_50072':
      return <AlertConfirmEditIcon {...props} />;
    default:
      return <IconDefaultEvent {...props} />;
  }
}
